/* tooltip */
$(function() {
    $('.Tooltip').each(function(i, tooltip) {
        var tooltipTrigger = '.tooltip';
        var tooltipContent = '.tooltip-content';
        var findtooltipTrigger = $(this).find(tooltipTrigger);
        var findtooltipContent = $(this).find(tooltipContent);

        // Apply ARIA and display values on load
        if (findtooltipTrigger.hasClass('__active')) {
            findtooltipTrigger.attr('aria-expanded', true);
            findtooltipContent.show();
            findtooltipContent.attr('aria-hidden', false);
        } else {
            findtooltipTrigger.attr('aria-expanded', false);
            findtooltipContent.hide();
            findtooltipContent.attr('aria-hidden', true);
        }

        // On click of tooltip trigger
        findtooltipTrigger.click(function(e) {
            e.preventDefault();
            /* close an open tooltip */
            if ($(this).hasClass('__active')) {
                $(this).attr('aria-expanded', false);
                $(this).removeClass('__active');
                findtooltipContent.fadeOut();
                findtooltipContent.attr('aria-hidden', true);
            } else {
                $(this).closest('ul').find('.tooltip').removeClass('__active');
                $(this).closest('ul').find('.tooltip-content').fadeOut();
                $(this).closest('ul').find('.tooltip-content').attr('aria-hidden', true);
                $(this).addClass('__active');
                $(this).attr('aria-expanded', true);
                $(this).closest('ul').find('.tooltip').attr('aria-expanded', false);
                findtooltipContent.attr('aria-hidden', false);
                findtooltipContent.fadeIn();
            }
        });
    });
});
